import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import {
  ChakraProvider,
  Stack,
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  InputGroup,
  InputLeftElement,
  Icon,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Button,
} from "@chakra-ui/react";
import { BsThreeDots } from "react-icons/bs";
import { SearchIcon } from "@chakra-ui/icons";
import { ThreeCircles } from "react-loader-spinner";
import {
  ChangeCustomerStatusService,
  SearchCustomersService,
} from "../../service/service";

function CustomersTable({
  userData,
  setUserData,
  totalPages,
  currentPage,
  handlePageChange,
  noData,
  itemsPerPage,
  setTotalPages,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchData(currentPage, searchText);
  }, [currentPage]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    fetchData(currentPage, event.target.value); // Keep the current page when searching
  };

  const handleActivateDeactivate = (user) => {
    const newStatus = !user.isActive;
    Swal.fire({
      title: `Are you sure you want to ${
        user.isActive ? "deactivate" : "activate"
      } this customer?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        ChangeCustomerStatusService({ id: user.id, status: newStatus })
          .then((response) => {
            if (response.status) {
              setIsLoading(false);
              fetchData(currentPage, searchText);              

              Swal.fire({
                icon: "success",
                title: `Customer ${
                  newStatus ? "activated" : "deactivated"
                } successfully!`,
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: response.message,
                icon: "error",
                timer: 3000,
                confirmButtonText: "OK",
              });
            }
          })
          .catch((error) => {
            setIsLoading(false);
            console.log(error.message);
            Swal.fire({
              title: "Error!",
              text: error.message,
              icon: "error",
              timer: 3000,
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  // const handleDelete = (user) => {
  //   Swal.fire({
  //     title: "Are you sure you want to delete this customer?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       setIsLoading(true);
  //       Delete({ userId: user.id })
  //         .then((response) => {
  //           setIsLoading(false);
  //           if (response.status) {
  //             fetchData(currentPage, searchText);
  //             Swal.fire({
  //               icon: "success",
  //               title: "Customer deleted successfully!",
  //               showConfirmButton: false,
  //               timer: 1500,
  //             });
  //           } else {
  //             Swal.fire({
  //               title: "Error!",
  //               text: response.message,
  //               icon: "error",
  //               timer: 3000,
  //               confirmButtonText: "OK",
  //             });
  //           }
  //         })
  //         .catch((error) => {
  //           setIsLoading(false);
  //           console.log(error.message);
  //           Swal.fire({
  //             title: "Error!",
  //             text: error.message,
  //             icon: "error",
  //             timer: 3000,
  //             confirmButtonText: "OK",
  //           });
  //         });
  //     }
  //   });
  // };

  const fetchData = (page = currentPage, search = searchText) => {
    setIsLoading(true);

    SearchCustomersService({
      searchText: search,
      per_page: itemsPerPage,
      page: page + 1,
    })
      .then((result) => {
        setIsLoading(false);
        if (result.status) {
          setUserData(result.data.data);
          setTotalPages(result.data.last_page); // Ensure totalPages is updated
        } else {
          Swal.fire({
            title: "Error!",
            text: result.message,
            icon: "error",
            timer: 3000,
            confirmButtonText: "OK",
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error.message);
        Swal.fire({
          title: "Error!",
          text: error.message,
          icon: "error",
          timer: 3000,
          confirmButtonText: "OK",
        });
      });
  };

  const userPermission = JSON.parse(localStorage.getItem("userPermissions"));
  const adminData = JSON.parse(localStorage.getItem("adminData"));

  const displayedUsers = userData;

  return (
    <div className="bg-[#F7F7F7] px-10 pb-8">
      {isLoading && (
        <div className="overlay">
          <div className="loaderImage-container">
            <ThreeCircles
              height="100"
              width="100"
              color="#F9F9F9"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="three-circles-rotating"
              outerCircleColor=""
              innerCircleColor=""
              middleCircleColor=""
            />
          </div>
        </div>
      )}
      <div className="relative overflow-x-auto shadow-md sm:rounded-2xl bg-white">
        <ChakraProvider>
          <Box width="100%" p="5">
            <Stack alignItems={"end"}>
              <InputGroup mb="4" w="30%">
                <InputLeftElement
                  pointerEvents="none"
                  children={<Icon as={SearchIcon} color="gray.300" />}
                />
                <Input
                  placeholder="Search"
                  value={searchText}
                  onChange={handleSearchChange}
                />
              </InputGroup>
            </Stack>
            {(adminData?.type === 0 || userPermission?.customer?.read) && (
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>Sr#</Th>
                    <Th>Name</Th>
                    <Th>Phone no</Th>
                    <Th>Address</Th>
                    <Th>Active Status</Th>
                    <Th>Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {displayedUsers?.map((user, index) => (
                    <Tr key={user.id}>
                      <Td>{index + 1 + currentPage * itemsPerPage}</Td>
                      <Td>{user.name}</Td>
                      <Td>{user.mobile}</Td>
                      <Td>{user.address}</Td>
                      <Td>{user.isActive ? "Active" : "Inactive"}</Td>
                      <Td>
                        <Menu>
                          <MenuButton
                            _hover={{ bg: "transparent" }}
                            bg={"transparent"}
                            as={Button}
                          >
                            <BsThreeDots />
                          </MenuButton>
                          <MenuList>
                            {(adminData?.type === 0 ||
                              userPermission?.customer?.update) && (
                              <MenuItem
                                onClick={() => handleActivateDeactivate(user)}
                              >
                                {user.isActive ? "Deactivate" : "Activate"}{" "}
                                Customer
                              </MenuItem>
                            )}
                            {/* {(adminData?.type === 0 ||
                              userPermission?.customer?.delete) && (
                              <MenuItem onClick={() => handleDelete(user)}>
                                Delete Customer
                              </MenuItem>
                            )} */}
                          </MenuList>
                        </Menu>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            )}
            <Text mt="4">
              Showing {displayedUsers.length} of {userData.length} rows
            </Text>
          </Box>
        </ChakraProvider>
        {userData.length === 0 && (
          <div className="flex h-[80px] items-center justify-center text-lg font-bold">
            {noData}
          </div>
        )}
        <div className="pagination w-full bg-whiteGrey px-6">
          <ReactPaginate
            className="flex justify-end items-center gap-x-3 h-[80px]"
            pageCount={totalPages}
            pageRangeDisplayed={5}
            marginPagesDisplayed={2}
            initialPage={currentPage}
            previousLabel={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M17.052 19.9968C17.337 19.6829 17.3113 19.1993 16.9947 18.9168L10.9244 13.5L16.9947 8.08324C17.3113 7.80069 17.337 7.31712 17.052 7.00317C16.767 6.68923 16.2793 6.66378 15.9627 6.94633L9.25534 12.9315C9.09281 13.0766 9 13.2832 9 13.5C9 13.7168 9.09281 13.9234 9.25534 14.0685L15.9627 20.0537C16.2793 20.3362 16.767 20.3108 17.052 19.9968Z"
                  fill="#161E2E"
                />
              </svg>
            }
            nextLabel={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.94801 19.9968C9.66304 19.6829 9.6887 19.1993 10.0053 18.9168L16.0756 13.5L10.0053 8.08324C9.6887 7.80069 9.66303 7.31712 9.94801 7.00317C10.233 6.68923 10.7207 6.66378 11.0373 6.94633L17.7447 12.9315C17.9072 13.0766 18 13.2832 18 13.5C18 13.7168 17.9072 13.9234 17.7447 14.0685L11.0373 20.0537C10.7207 20.3362 10.233 20.3108 9.94801 19.9968Z"
                  fill="#161E2E"
                />
              </svg>
            }
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
}

export default CustomersTable;
